module.exports = __webpack_public_path__ + "static/img/move_product_01.fb05b16.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/move_product_01.png
// module id = gKr3
// module chunks = 0